// -----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { OnePlayerIframe } from '../common/onePlayerIframe';
import type { ITokenRetriever } from '../types/external';
import type { OnPreSessionErrorCallback } from '../types/internal';
import { GenericFileEmbedLoader } from '../genericFileEmbed/genericFileEmbedLoader';
import { webinarNavigateIframeToEmbedAsync } from './webinarNavigateIframeToEmbed';

export class WebinarGenericFileEmbedLoader extends GenericFileEmbedLoader {
  protected createOnePlayerIframe(
    embedUrl: string,
    containerDiv: HTMLDivElement,
    tokenRetriever: ITokenRetriever,
    onError: OnPreSessionErrorCallback,
    allowFullScreen?: boolean | undefined
  ): OnePlayerIframe {
    return new OnePlayerIframe(
      embedUrl,
      containerDiv,
      tokenRetriever,
      onError,
      allowFullScreen,
      webinarNavigateIframeToEmbedAsync
    );
  }
}
